import { InputDocumentStatus, OutputDocumentStatus } from "@/types";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { ReloadIcon } from "@radix-ui/react-icons";
import { ToggleGroupItem } from "./ui/toggle-group";

export const StatusBadge = (props: {
  status: InputDocumentStatus | OutputDocumentStatus;
}) => {
  let badgeColor;
  switch (props.status) {
    case "generating":
      badgeColor = "bg-blue-500 hover:bg-blue-500";
      break;
    case "processing":
      badgeColor = "bg-yellow-500 hover:bg-yellow-500";
      break;
    case "completed":
      badgeColor = "bg-green-500 hover:bg-green-500";
      break;
    case "failed":
      badgeColor = "bg-red-500 hover:bg-red-500";
      break;
  }

  const formatStatus = (status: string) => {
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <Badge className={cn(badgeColor, "text-white cursor-default")}>
      {formatStatus(props.status)}{" "}
      {["generating", "processing"].includes(props.status) && (
        <ReloadIcon className="ml-2 h-2 w-2 animate-spin" />
      )}
    </Badge>
  );
};

const Status = (props: { value: string; label: string; className: string }) => {
  return (
    <ToggleGroupItem
      value={props.value}
      aria-label={`Toggle ${props.value}`}
      className={cn(
        "h-7 w-18 rounded-full data-[state=on]:text-white data-[state=off]:text-gray-400",
        props.className
      )}
    >
      {props.label}
    </ToggleGroupItem>
  );
};
